// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"82":"95029402","247":"b47c30cc","627":"34eae0b9","768":"9bb6d580","806":"bdc72cbe","834":"7d7e7701","923":"18dcc3a5","938":"f21eb0f0"}[chunkId] + ".chunk.js";
};